import React, { useEffect, useRef, useState } from 'react';
import { IDataGridError } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridError';
import { ReactComponent as DownIcon } from 'components/icons/down.svg';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import {
  Error,
  ErrorWrapper,
  ExpandIcon,
  MultipleErrors,
  MultipleErrorsWrapper,
  SingleError,
  StyledErrorIcon,
  StyledSelectList,
} from './styles/ErrorContentStyles';

interface IProps {
  errors: IDataGridError[];
  isFirstPlayInInning: boolean;
}

const ErrorContent: React.FC<IProps> = (props) => {
  const { errors, isFirstPlayInInning } = props;
  const iconRef = useRef<any>();
  const { isListBelowBottom, isErrorListVisible, toggleList, setIsListBelowBottom } = useSelectList(iconRef);

  return (
    <ErrorWrapper isFirstPlayInInning={isFirstPlayInInning}>
      {errors.length > 0 && <StyledErrorIcon />}
      {errors.length === 1 && <SingleError>{errors[0].errorMessage}</SingleError>}
      {errors.length > 1 && (
        <MultipleErrorsWrapper>
          <MultipleErrors>{errors.length} errors</MultipleErrors>

          <ExpandIcon isExpanded={isErrorListVisible}>
            <DownIcon ref={iconRef} onClick={toggleList} />
          </ExpandIcon>

          <StyledSelectList
            visible={isErrorListVisible}
            isBelowBottomCallback={(isBelow: boolean) => setIsListBelowBottom(isBelow)}
            top={isListBelowBottom ? 'auto' : '50px'}
            bottom={isListBelowBottom ? '50px' : 'auto'}
          >
            {errors.map((error: IDataGridError, index: number) => {
              return <Error key={index}>{error.errorMessage}</Error>;
            })}
          </StyledSelectList>
        </MultipleErrorsWrapper>
      )}
    </ErrorWrapper>
  );
};

export default ErrorContent;

function useSelectList(iconRef: any) {
  const [isListBelowBottom, setIsListBelowBottom] = useState<boolean>(false);
  const [isErrorListVisible, setIsErrorListVisible] = useState<boolean>(false);

  useOnClickOutside(iconRef, () => {
    setIsErrorListVisible(false);
  });

  const handleOnClick = () => {
    setIsErrorListVisible(!isErrorListVisible);
  };

  return {
    isListBelowBottom,
    isErrorListVisible,
    toggleList: handleOnClick,
    setIsListBelowBottom,
  };
}
